import script from "./TabCoaches.vue?vue&type=script&setup=true&lang=js"
export * from "./TabCoaches.vue?vue&type=script&setup=true&lang=js"

import "./TabCoaches.vue?vue&type=style&index=0&id=06d88dd4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06d88dd4"]])

export default __exports__